/**
 * Delay any change of the property textContent on an element
 * @param {HTMLButtonElement} element - HTML Button element
 * @param {Obj} param1 - Object with text, previousText, time of setTimeout, and timerId
 * @returns {string} - setTimeout id value
 */
export function delayUpdate(element, { text, previousText, ms, timerId }) {
  if (timerId) {
    clearTimeout(timerId);
  }

  element.textContent = text;

  return setTimeout(() => {
    element.textContent = previousText;
  }, ms);
}
